import React, {useState} from 'react'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import {Input} from '../../components/forms/inputs'
import Form from '../../components/forms'
import type {Alarm as AlarmType, Evaluation, TriggerCadence, Model} from '../../services/types'
import {itemsSelect, CadenceSelect, MetricSelect, ThresholdInput, VisibilityToggle} from './widgets'
import Path from '../../routeLinks'

type CreateFormProps = {
  onSave: (a: AlarmType) => Promise<string | null>
  allEvals: Evaluation[]
  allModels: Model[]
}
export const CreateForm = ({onSave, allEvals, allModels}: CreateFormProps) => {
  const [invalid, setInvalid] = useState(false)
  const [name, setName] = useState('')
  const [desc, setDesc] = useState('')
  const [evaluation, setEvaluation] = useState<Evaluation>()
  const [models, setModels] = useState<string[]>([])
  const [metric, setMetric] = useState('')
  const [threshold, setThreshold] = useState(0)
  const [cadence, setCadence] = useState<TriggerCadence>()
  const [isPublic, setIsVisible] = useState(false)

  const isInvalid = () => !name || !evaluation || !metric

  const onSubmit = async () =>
    onSave({
      name,
      description: desc,
      evaluation_id: evaluation?.id,
      models: allModels.filter((m) => models.includes(m.id)),
      metric,
      trigger_cadence: cadence as TriggerCadence,
      threshold,
      public: isPublic,
    } as AlarmType)

  const EvalsSelect = itemsSelect('Evaluation', allEvals)
  const ModelsSelect = itemsSelect('Models', allModels)

  return (
    <Form
      actionLabel="Create alarm"
      isInvalid={isInvalid}
      setInvalid={setInvalid}
      submitter={onSubmit}
      action={Path.user.alarms()}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Input
            label="Name"
            defaultValue={name}
            setter={setName}
            validate={invalid}
            validator={(v) => !v && 'Name is required'}
            sx={{width: '100%'}}
          />
        </Grid>

        <Grid item md={9} sm={6} xs={12}>
          <Input
            label="Description"
            defaultValue={desc}
            validate={invalid}
            setter={setDesc}
            multiline
            sx={{width: '100%'}}
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <Stack spacing={1.5}>
            <EvalsSelect
              value={evaluation?.id}
              validate={invalid}
              onChange={(evalId: string) =>
                setEvaluation(allEvals.filter(({id}) => id === evalId)[0])
              }
            />
            <ModelsSelect value={models} multiple onChange={setModels} />
          </Stack>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <MetricSelect
            value={metric}
            onChange={setMetric}
            validate={invalid}
            sx={{width: '100%'}}
          />
        </Grid>
        <Grid item md={3} sm={3} xs={12}>
          <ThresholdInput value={threshold} validate={invalid} onChange={setThreshold} />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <CadenceSelect
            value={cadence}
            onChange={setCadence}
            validate={invalid}
            sx={{width: '100%'}}
          />
        </Grid>

        <Grid item sm={2} xs={6}>
          <VisibilityToggle value={isPublic} validate={invalid} onChange={setIsVisible} />
        </Grid>
      </Grid>
    </Form>
  )
}

export default CreateForm
